export default "__VITE_ASSET__8dc8c67a__"